export const EmailPattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g
export const passwordPattern = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹]).{8,}$/;
export const lettersOnly = /(^[a-zA-Z ]+$)|(^[\u0621-\u064A ]+$)/g;
export const numbersOnly = /^\d*$/;
export const urlPattern = /^(([fF][tT][pP]|[hH][tT][tT][pP]|[hH][tT][tT][pP][sS]):\/\/)?(www.)?(?!.*([fF][tT][pP]|[hH][tT][tT][pP]|[hH][tT][tT][pP][sS]|www.))[a-zA-Z\d_-]+(\.[a-zA-Z]+)+((\/)[\w#-_]+)*(\/\w+\?\w+=\w+(&\w+=\w+)*)?$/gm
